import {createAction} from "@reduxjs/toolkit";

export const setEventTypes = createAction('SET_EVENT_TYPES');